import { createSlice } from "@reduxjs/toolkit";
import { NotificationDefaultDataset } from "../data_model/notificationModel/notififcation_model";

export const new_notification = createSlice({
  name: "new_notification",
  initialState: {
    value: {
      status: false,
      langMap: NotificationDefaultDataset,
      defaultLangMap: NotificationDefaultDataset,
    },
  },
  reducers: {
    //create first data item
    resetLangMap: (state, action) => {
      state.value.langMap = NotificationDefaultDataset;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      state.value.status = true;
      const newPayload = action.payload;
      const existingPayload = state.value.langMap.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } =
  new_notification.actions;

export default new_notification.reducer;
